module.exports = __webpack_public_path__ + "bef953d6c3eedf9f5697b76d40d1acb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/v/v06.jpg
// module id = 754
// module chunks = 0